var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","dir":("" + (_vm.$i18n.locale)) == 'ar' ? 'rtl' : 'ltr'}},[_c('Navbar',{staticClass:"z-50"}),_c('router-view',{staticClass:"z-0"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }